/* eslint-disable @typescript-eslint/naming-convention */
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
const ChatWidgetContext = createContext(null);
// ---------------------------------------------------------------------------
// Provider
// ---------------------------------------------------------------------------
export function ChatWidgetContextProvider({ children }) {
    var _a, _b;
    // One state object, not two: a prompt and its files must reach the composer in the same render
    // (React 17 does not batch updates made outside event handlers, so two setters could be seen apart).
    const [retryDraft, setRetryDraft] = useState(null);
    const [focusInputSignal, setFocusInputSignal] = useState(0);
    const setRetryPrompt = useCallback((prompt, files) => {
        setRetryDraft({ prompt, files: files && files.length > 0 ? files : null });
    }, []);
    const clearRetryPrompt = useCallback(() => {
        setRetryDraft(null);
    }, []);
    const triggerFocusInput = useCallback(() => {
        setFocusInputSignal((n) => n + 1);
    }, []);
    const retryPrompt = (_a = retryDraft === null || retryDraft === void 0 ? void 0 : retryDraft.prompt) !== null && _a !== void 0 ? _a : null;
    const retryFiles = (_b = retryDraft === null || retryDraft === void 0 ? void 0 : retryDraft.files) !== null && _b !== void 0 ? _b : null;
    const value = useMemo(() => ({ retryPrompt, retryFiles, setRetryPrompt, clearRetryPrompt, focusInputSignal, triggerFocusInput }), [retryPrompt, retryFiles, setRetryPrompt, clearRetryPrompt, focusInputSignal, triggerFocusInput]);
    return React.createElement(ChatWidgetContext.Provider, { value: value }, children);
}
// ---------------------------------------------------------------------------
// Hook
// ---------------------------------------------------------------------------
export function useChatWidgetContext() {
    const ctx = useContext(ChatWidgetContext);
    if (!ctx) {
        throw new Error('useChatWidgetContext must be used within a ChatWidgetContextProvider');
    }
    return ctx;
}
